export default __webpack_public_path__ + "8d76cbaf58eee8efeb376e6c6f410ad8.svg";